import primaryColour from "../../constants";
import type { EventMarkerProps } from "./EventMarker";
import { getEventType } from "./EventMarker";

interface EventCircleProps extends EventMarkerProps {
  halo?: boolean;
}

function SvgEventCircle(props: EventCircleProps) {
  const { eventType, halo, fill = primaryColour, ...svgProps } = props;

  if (halo) {
    return (
      <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
        <rect width={32} height={32} rx={16} fill={fill} fillOpacity="0.2" />
        <circle cx="16" cy="16" r="12" fill={fill} />
        <g transform="translate(4,4)">{getEventType(eventType, "#ffffff")}</g>
      </svg>
    );
  }

  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <rect width={24} height={24} rx={12} fill={fill} />
      {getEventType(eventType, "#ffffff")}
    </svg>
  );
}

export default SvgEventCircle;
